import { IVariable } from "../../interfaces/IVariable";
import { createTheme, Theme } from "@mui/material/styles";
import { darkenColor } from "../../util/helpers";
import { getlocalStorageIdHotsite } from "../../util/LocalStorage";


// UrlLoja:"https://prd-ecommerce-und-api.primecase.com.br/api"

let idHotsiteLocalStorage = getlocalStorageIdHotsite();


export const variables: IVariable = {
  IdHotsite: idHotsiteLocalStorage,
  Loja: "labor",
  UserStorage: "iMcUgzgH+EuZoaXFoUeQIA==",
  UserToken: "PzEMambPT0uu/L7K9pOefg==",
  UrlApi: "https://prd-ecommerce-lbr-api.primecase.com.br/api",
  UrlLoja:"https://laborcambiopay.com.br/",
  UrlServiceHost: "https://dev2-pri-sgc-api.primecase.com.br/",

  OrgId: "",
  ProviderMerchantId: ""
};

export const template: Theme = createTheme({
  palette: {
    primary: {
      main: "#990937",
      light: "#84052d",
      //lighter: "#ece6f7",
      dark: darkenColor("#84052d", 10), // Escurece em 20%
    },
    secondary: {
      main: "#8e3652",
    },
    error: {
      main: "#a91c1c",
    },
    text: {
      primary: "#222",
      //light: "#fff",
    },
    warning: {
      main: "#ff9800",
    },
    // white: {
    //   main: "#fff",
    // },
  },

  typography: {
    subtitle1: {
      fontSize: 12,
    },
    body1: {
      fontSize: 14,
    },
  },
});
